// El proveedor de imagen que el chat FUERZA en sus generaciones, o null para la cadena
// de producción — ADR-2026-09-12-gpt-image-2-5-en-el-harness-y-en-el-agente.
//
// Lo elige "Opciones de modelo avanzadas" en el menú del "+", abierto a cualquier cuenta
// con el Agente (ADR-2026-09-14-el-modelo-de-imagen-lo-elige-el-usuario; nació como la
// tuerca de las cuentas dev), y lo leen TODAS las tarjetas que generan imágenes
// —`FreeformGenerateCard`, `LoteImagenesCard` y `ConfirmGenerateCard` (producto + modelo)—
// para mandarlo como `provider_override`. Que una sola se lo olvide es invisible: la
// imagen sale igual, por otro motor. Es un contexto aparte y no un campo de
// `AgentEnvContext` porque el valor vive en `ChatAtlasProvider`, que está por DEBAJO del
// entorno.
//
// OJO: `ChatAtlasProvider` envuelve TODAS las rutas (`ChatAtlasRaiz` en App.tsx), así que
// el valor del Chat le llegaría también al asistente de "Crear desde cero", que monta las
// mismas tarjetas pero no tiene tuerca. `InterfazV2` lo corta con
// `SinProveedorDeImagenForzado`: ahí siempre corre la cadena de producción.

import { createContext, createElement, useContext, type ReactNode } from 'react';
import type { ProveedorDeImagen } from '../../lib/proveedoresDeImagen';

export const ProveedorDeImagenContext = createContext<ProveedorDeImagen | null>(null);

export const useProveedorDeImagen = (): ProveedorDeImagen | null =>
  useContext(ProveedorDeImagenContext);

/** Corta el proveedor forzado del Chat para su subárbol: adentro vale null. */
export const SinProveedorDeImagenForzado = ({ children }: { children: ReactNode }) =>
  createElement(ProveedorDeImagenContext.Provider, { value: null }, children);
